module.exports = __webpack_public_path__ + "static/media/blog-card.58808458.JPG";